module.exports = __webpack_public_path__ + "static/media/terms-and-conditions.4dd38046.pdf";